import { FC, ReactNode, useState } from 'react'
import { useAsync } from 'react-use'
import type { ContactCenterUserContext as UserContext } from '@ucc/admin-global-state'
import { Analytics } from '@ucc/unified-admin-common'

import { ContactCenterUserContext } from 'components'
import { useAccountContext } from 'components/contexts/AccountContext'
import { useConnectedUserContext } from 'components/contexts/ConnectedUserContext'
import { fetchUserContext, getAnalyticsUserAccess } from 'utils'

interface ContactCenterUserProviderProps {
  children?: ReactNode
}

const ContactCenterUserProvider: FC<ContactCenterUserProviderProps> = ({ children }) => {
  const [userContext, setUserContext] = useState<UserContext | null>(null)
  const iAm = useConnectedUserContext()
  const [loading, setLoading] = useState(false)
  const { orgId: selectedPbxId } = useAccountContext()

  useAsync(async () => {
    // user context should be called once on load or when pbx changes
    if (selectedPbxId && iAm?.key && !loading && (!userContext || userContext.organizationId !== selectedPbxId)) {
      setLoading(true)
      const context = await fetchUserContext(selectedPbxId)
      setLoading(false)
      if (context) {
        setUserContext({
          ...context,
          organizationId: selectedPbxId,
        })
        Analytics.identify(iAm.key, getAnalyticsUserAccess(context))
      }
    }
  }, [selectedPbxId, iAm?.key])

  return <ContactCenterUserContext.Provider value={{ userContext }}>{children}</ContactCenterUserContext.Provider>
}

export default ContactCenterUserProvider
